/**
 * Feature Flag Logger
 *
 * Structured logging for the FeatureFlags module.
 * Pattern: SMP: [FeatureFlags] <message> { context }
 *
 * - SMP: is the package-level prefix (consistent with other SMP services)
 * - [FeatureFlags] is the module-level prefix
 *
 * Filter in DevTools: "SMP: [FeatureFlags]"
 */

const PACKAGE_PREFIX = 'SMP:'
const MODULE_PREFIX = '[FeatureFlags]'
const PREFIX = `${PACKAGE_PREFIX} ${MODULE_PREFIX}`

/** Runtime debug toggle -- set via window.__SMP_FF_DEBUG = true in DevTools */
function isDebugEnabled (): boolean {
    try {
        return (window as any).__SMP_FF_DEBUG === true ||
            new URLSearchParams(window.location.search).get('ff_debug') === 'true'
    } catch {
        return false
    }
}

export const logger = {
    /** Info-level: lifecycle events -- ALWAYS emitted (not gated by debug flag) */
    info (message: string, context?: Record<string, unknown>): void {
        console.log(`${PREFIX} ${message}`, context ?? '')
    },

    /** Warn-level: recoverable issues (fetch timeout, stale cache used, unknown flag) */
    warn (message: string, context?: Record<string, unknown>): void {
        console.warn(`${PREFIX} ${message}`, context ?? '')
    },

    /** Error-level: unrecoverable failures (fetch error, invalid response) */
    error (message: string, context?: Record<string, unknown>): void {
        console.error(`${PREFIX} ${message}`, context ?? '')
    },

    /** Debug-level: verbose (cache operations, TTL checks, individual flag reads) -- gated */
    debug (message: string, context?: Record<string, unknown>): void {
        if (isDebugEnabled()) {
            console.debug(`${PREFIX} ${message}`, context ?? '')
        }
    },
}
